// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + {"863":"bcc39da5eecc9843810618357b626ef5","871":"5aed79a65bdc8029c32f9c1bc62c225c"}[chunkId] + ".js";
};